import { PageHeaderWrapper } from '@ui';
import styled from 'styled-components';

export const EVisitsSC = styled(PageHeaderWrapper)`
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  overflow: hidden;

  .page-children {
    /* padding-left: -20px; */
    /* margin-right: -10px; */
    padding-top: 14px;
    padding-bottom: 0;

    .ui-calendar-week-header {
      margin: 0;
    }

    .row {
      .time {
        display: block;
        padding-left: 0;
        text-align: left;
      }
    }

    .day-progress {
      .time {
        margin-left: -12px;
      }
    }
  }

  .header-title-extra {
    display: flex;
    align-items: center;
    gap: 16px;

    .ui-select {
      min-width: 270px;
    }
  }

  .action-dock {
    position: fixed;
    left: 190px;
    right: 0;
    bottom: 0;
    z-index: 9998;
    height: 85px;
    padding: 8px 22px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    background: #fff;
    box-shadow: 0 2px 8px rgba(24, 30, 52, 0.08), 0 2px 15px rgba(51, 61, 108, 0.1);
  }
` as typeof PageHeaderWrapper;

export const EVisitsContent = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
`;

export const CalendarCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .locations {
    max-width: calc(100vw - 190px);
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .calendar {
    background: white;
    padding-bottom: 154px;
  }
`;

export const OfficeHoursCol = styled.div`
  position: sticky;
  top: 0;
  width: 345px;
  padding: 26px;
`;

export const EmptySC = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;

  h3 {
    line-height: 1.5;
    color: #a3a5ae;
    font-weight: 800;
    font-size: 20px;
    margin-bottom: 16px;
  }

  p {
    font-weight: 600;
    margin-bottom: 32px;
  }

  .icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: linear-gradient(
      180deg,
      rgba(163, 165, 174, 0) 0%,
      rgba(163, 165, 174, 0) 20%,
      rgba(163, 165, 174, 0.05) 70%,
      rgba(163, 165, 174, 0.2) 100%
    );
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
